module.exports = __webpack_public_path__ + "static/img/vote-04.d921492.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vote/vote-04.png
// module id = 0VWM
// module chunks = 1